import { useCallback } from 'react';

import { updateIsReadyToUseLK, markDataAsStale, initializeAccountData } from 'application/store/slices/accountSlice';
import RootFrontendUtils from 'application/utils/RootFrontendUtils';
import { useAppDispatch } from 'application/providers/StoreProvider';

import { UserDataType } from '@entities/auth';

export const useAccountSync = () => {
  const dispatch = useAppDispatch();

  const syncAccountData = useCallback(
    (userData: UserDataType) => {
      if (!userData) return false;

      const currentCompany = userData?.mainCompany;
      const isReadyToUseLK = RootFrontendUtils.isReadyToUseLK(userData, currentCompany);

      dispatch(updateIsReadyToUseLK(isReadyToUseLK));
      dispatch(markDataAsStale());

      if (isReadyToUseLK && currentCompany?.id) {
        dispatch(initializeAccountData(currentCompany.id));
      }

      return isReadyToUseLK;
    },
    [dispatch]
  );

  return { syncAccountData };
};
